import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export const ButtonCreateEvent = ({ openCreate }) => {
  const { t } = useTranslation();
  const handleClickButtonCreateEvent = () => {
    openCreate();
  };

  return (
    <Button type="primary" onClick={handleClickButtonCreateEvent}>
      {t('governmentServiceEducation.create')}
    </Button>
  );
};
